module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.f2d8343.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-Regular.ttf
// module id = 704
// module chunks = 3